import { ModuleId } from 'src/app/components/module/store/module.model';
import { Observable, of, Subject } from 'rxjs';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  NzTableFilterFn,
  NzTableFilterList,
  NzTableSortFn,
  NzTableSortOrder,
} from 'ng-zorro-antd/table';
import { ActionId } from '../../store/action.model';
import { Store } from '@ngrx/store';
import { ActionState } from '../../store/action.reducer';
import * as fromActionAction from '../../store/action.actions';

interface DataItem {
  name: string;
  age: number;
  address: string;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  listOfFilter: NzTableFilterList;
  filterFn: NzTableFilterFn<DataItem> | null;
  filterMultiple: boolean;
  sortDirections: NzTableSortOrder[];
}
@Component({
  selector: 'app-action-table',
  templateUrl: './action-table.component.html',
  styleUrls: ['./action-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionTableComponent implements OnInit {
  @Input() source: ActionId[] | any = [];
  @Input() icon: string = '';
  @Input() noDataTitle: string = 'Aucun élément trouvé';
  @Input() addItemTitle: string = 'Ajouté un nouvel élément';
  @Input() scroll: any = { y: '300px' };

  @Output() select = new EventEmitter(false);
  @Output() add = new EventEmitter(false);
  @Output() update = new EventEmitter(false);
  @Output() delete = new EventEmitter(false);
  @Output() export = new EventEmitter(false);
  subscribe = new Subject();

  listOfColumns: ColumnItem[] = [
    {
      name: 'Name',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => a.name.localeCompare(b.name),
      sortDirections: ['ascend', 'descend', null],
      filterMultiple: true,
      listOfFilter: [
        { text: 'Joe', value: 'Joe' },
        { text: 'Jim', value: 'Jim', byDefault: true },
      ],
      filterFn: (list: string[], item: DataItem) =>
        list.some((name) => item.name.indexOf(name) !== -1),
    },
    {
      name: 'Age',
      sortOrder: 'descend',
      sortFn: (a: DataItem, b: DataItem) => a.age - b.age,
      sortDirections: ['descend', null],
      listOfFilter: [],
      filterFn: null,
      filterMultiple: true,
    },
    {
      name: 'Address',
      sortOrder: null,
      sortDirections: ['ascend', 'descend', null],
      sortFn: (a: DataItem, b: DataItem) => a.address.length - b.address.length,
      filterMultiple: false,
      listOfFilter: [
        { text: 'London', value: 'London' },
        { text: 'Sidney', value: 'Sidney' },
      ],
      filterFn: (address: string, item: DataItem) =>
        item.address.indexOf(address) !== -1,
    },
  ];
  listOfData: DataItem[] = [
    {
      name: 'John Brown',
      age: 32,
      address: 'New York No. 1 Lake Park',
    },
    {
      name: 'Jim Green',
      age: 42,
      address: 'London No. 1 Lake Park',
    },
    {
      name: 'Joe Black',
      age: 32,
      address: 'Sidney No. 1 Lake Park',
    },
    {
      name: 'Jim Red',
      age: 32,
      address: 'London No. 2 Lake Park',
    },
  ];

  constructor(private actionStore: Store<ActionState>) {}

  ngOnInit(): void {
    this.loadActionUtils();
  }
  ngOnChanges(changes: SimpleChanges): void {}
  ngOnDestroy(): void {
    this.subscribe.next(false);
    this.subscribe.complete();
  }

  onSelect(item: any): void {
    if (!item) return;
    this.select.emit(item);
  }

  onSelectDropdown(event: string): void {
    if (!event) return;
  }

  loadActionUtils(): void {
    this.actionStore.dispatch(fromActionAction.loadActionTypes());
  }
}
